import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import Router from "./Router";
import { store } from "./redux/store";
import { ConfigProvider } from "antd";

function App() {
  return (
    <Provider store={store}>
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Inter, sans-serif",
        },
      }}
    >
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </ConfigProvider>
    </Provider>
  );
}

export default App;
